import React from 'react';

import { createTrackingHoc } from '@xingternal/malt-tracking';

// postpones creation of createTrackingHoc until asynchronous data is loaded
const asyncTrackingHoc =
  (...trackingProps) =>
  (contextFn) =>
  (WrappedComponent) => {
    let Component = WrappedComponent;
    let isHocRendered = false;

    return class extends React.Component {
      static displayName = `WithAsyncTracking(${
        Component.displayName || Component.name
      })`;

      render() {
        const context = contextFn(this.props);

        if (!isHocRendered && context) {
          Component = createTrackingHoc(...trackingProps)(context)(
            WrappedComponent
          );
          isHocRendered = true;
        }

        return <Component {...this.props} />;
      }
    };
  };

export default asyncTrackingHoc;
